import React, { useEffect, useState } from "react";
import {
  useCreateConsentMasterMutation,
  useUpdateConsentMasterMutation,
} from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";
import { toast } from "react-toastify";
import "./styles.scss";

interface IPROPS {
  closeModal: any;
  storedWorkshopData: any;
  refetch: any;
  consentMasterData: any;
}

const UpdateConsentMaster: React.FC<IPROPS> = ({
  closeModal,
  storedWorkshopData,
  refetch,
  consentMasterData,
}) => {
  const [name, setName] = useState(storedWorkshopData?.name);
  const [consentId, setConsentId] = useState(storedWorkshopData?.code);
  const [mandatoryCategory, setMandatory] = useState(
    storedWorkshopData?.is_mandatory
  );
  // const [consentCategory,setConsentCategory] = useState('')
  // const [promotionalCategory,setPromotionalCategory] = useState('')
  const [desc, setDesc] = useState(storedWorkshopData?.description);

  const [createMasterLoader, setCreateMasterLoader] = useState(false);
  const [updateConsentMasterTrigger, { status }] =
    useUpdateConsentMasterMutation();

  useEffect(() => {
    if (status === "pending") {
      setCreateMasterLoader(true);
    } else {
      setCreateMasterLoader(false);
    }
  }, [status]);

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const saveConsentMaster = async () => {
    const payload = {
      name: name, // Required, max length 255
      code: consentId, // Required, max length 50, must be unique
      description: desc, // Optional
      is_mandatory: mandatoryCategory,
      is_active: "true",
    };
    const response = await updateConsentMasterTrigger({
      id: storedWorkshopData?.id,
      body: payload,
    });

    try {
      if (response?.data) {
        closeModal();
        toast.success("Consent saved successfully");
        refetch();
      }
    } catch (error) {
      toast.error("An error occured");
    }
  };

  return (
    <div style={{ padding: "10px" }} className="update-conent-cont">
      <div
        className="update-consent-sub-cont"
        // className="vehicle-info-middle"
        style={{
          boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
          borderRadius: "40px",
        }}
      >
        <div
          // className="vehicle-info-middle-heading"
          className="update-consent-heading"
          style={{
            borderBottom: "1px solid #C7C8CA",
            padding: "15px 30px",
            color: "#6C6D70",
            // fontSize: "20px",
          }}
        >
          Update Consent
        </div>
        <div
          className="update-consent-content"
          // className="vehicle-info"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "15px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              padding: "10px",
            }}
          >
            <div className="update-consent-label" style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "5px",
                  }}
                >
                  Name
                </span>
                <span>
                  <input
                    style={{
                      borderRadius: "20px",
                      background: "#FCFCFC",
                    }}
                    className="form-control"
                    type="text"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    placeholder="Name"
                  />
                </span>
              </p>
            </div>

            <div className="update-consent-label" style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "5px",
                  }}
                >
                  Consent Type
                </span>
                <span>
                  <select
                    disabled
                    value={consentId}
                    onChange={(e) => setConsentId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                    }}
                  >
                    <option>Select an option</option>
                    {consentMasterData?.map((el: any, ind: any) => (
                      <option value={el?.code}>{el?.code}</option>
                    ))}
                  </select>

                  {/* <input
                                    style={{
                                        borderRadius: "20px",
                                        background: "#FCFCFC",
                                    }}
                                    className="form-control"
                                    type="text"
                                    onChange={(e) =>
                                        setConsentId(e.target.value)
                                    }
                                    value={consentId}
                                    placeholder="Consent code"
                                /> */}
                </span>
              </p>
            </div>

            <div className="update-consent-label" style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "5px",
                  }}
                >
                  Mandatory
                </span>
                <span>
                  <select
                    disabled
                    value={mandatoryCategory}
                    onChange={(e) => setMandatory(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                    }}
                  >
                    <option>Select option</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </span>
              </p>
            </div>
          </div>
          <div style={{ padding: "10px" }} className="update-consent-label">
            <textarea
              value={desc}
              onChange={(e) => {
                const lettersOnly = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                setDesc(lettersOnly);
              }}
              placeholder="Enter Description"
              style={{
                width: "100%",
                borderRadius: "40px",
                padding: "10px 20px",
                background: "#FFF1EC",
                border: "none",
              }}
            />{" "}
          </div>
          <div
            style={{ display: "flex", justifyContent: "end" }}
            className="update-consent-label"
          >
            <button
              onClick={saveConsentMaster}
              // onClick={createVehicleDataHandler}
              // disabled={!brandName.trim()}
              style={{
                // background:!consentId.trim() ?  "#F7D3C5" :  `${selectedButtonBackgoundColors}`,
                background: `${selectedButtonBackgoundColors}`,
                color: `${selectedButtonColors}`,
                border: "none",
                padding: "10px 20px",
                borderRadius: "20px",
                fontSize: "15px",
                //    cursor: consentId.trim() ? "pointer" : "not-allowed",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateConsentMaster;
